//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  useState,
  useCallback,
  useEffect,
  Fragment,
  useContext,
} from "react";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import report from "apis/Report/Report";
import { PointsBalance } from "./config/config";
import { toastCss, successCss } from "assets/styleJS/global";
import NoData from "components/Table/NoData";
import Loader from "components/Loader/Loader";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import {
  DatePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";

// material-ui icons
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import { useTranslation } from 'react-i18next';
import {dateFormat} from "helpers/dataFormat"
const GlobalCss = withStyles({
  "@global": {
    " .MuiDialog-scrollPaper": {},
    ".MuiDialog-paperWidthSm": {
      overflow: "hidden",
      maxWidth: "none",
    },
    " .MuiDialog-paper ": {},
  },
})(() => null);

export default function PointsBalanceFunc(props) {
  const { state, dispatch } = useContext(Context);
  const { page, setDisableDropdown } = props;
  const { pointsBalanceAPI } = report();
  const classes = styles();
  const { t, i18n } = useTranslation()
  const [selectedDate, handleDateChange] = useState(new Date());

  const [states, setstates] = useState({
    columns: [],
    selectedColumns: [],
    selectedFields: [],
    selectedHeaders: [],
    dialog: false,
    data: [],
    response: false,
    startDate: new Date(),
    endDate: new Date(),
    dateApplied: false,
    filterColumn: "",
    filterValue: "",
    filterApplied: false,
    groupBy: "",
    groupByApplied: false,
    pLoading: false,
    eLoading: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // setting checkboxes
  useEffect(() => {
    let label = PointsBalance?.columns?.map((c) => c.label);
    if(state?.userInfo?.loyalty_organization_name == 'Henry Schein Canada'){
      let index = label.indexOf("Consecutive Negative (days)");
      let x = label.splice(index, 1);
      index = label.indexOf("Available To Redeem");
       x = label.splice(index, 1);

   
    }
    setStates({ columns: label, selectedColumns: label });
  }, []);

  // PointsBalance api func
  const handlePointsBalance = async () => {
    try {
      setDisableDropdown(true);
      let selectedColumnKeys = [];

      let selectedObj = [];
      let selectedHeaders = [];

      states.selectedColumns.map(
        (s) => (selectedObj = [...selectedObj, { label: s }])
      );

      PointsBalance.columns.map((c) => {
        selectedObj.map((s) => {
          if (c.label === s.label) {
            selectedHeaders = [...selectedHeaders, { ...c, label: t(c.label) }];
          }
        });
      });

      PointsBalance.columns.map((c, i) => {
        if (states.selectedColumns?.includes(c.label)) {
          selectedColumnKeys = [...selectedColumnKeys, c.key];
          return;
        }
      });

      setStates({
        selectedFields: selectedColumnKeys,
        selectedHeaders: selectedHeaders,
      });

      let values = {
        fields: selectedColumnKeys,
      };
      if (states.dateApplied) {
        values = {
          ...values,
          startDate: states.startDate,
          endDate: states.endDate,
        };
      }
      if (states.filterApplied) {
        values = {
          ...values,
          filterBy: { [states.filterColumn]: [states.filterValue] },
        };
      }
      if (states.groupByApplied) {
        values = { ...values, groupBy: states.groupBy };
      }
      let res = await pointsBalanceAPI(values);
      if (res && res.data) {
        dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
        setStates({
          data: res.data,
        //   .map(item => {
        //     if (item.negative_count == 0) {
        //         return { ...item, negative_count: '0 days' };
        //     } else {
        //         return { ...item, negative_count: item.negative_count + ' days' };
        //     }
        // }),
          response: true,
          pLoading: false,
          eLoading: false,
        });
        setDisableDropdown(false);
        if (res.data.length === 0) {
          toast.success(t("No Data Found"), { toastId: "no-report-date" });
          return;
        }
        return true;
      }
    } catch (err) {
      console.log(err);
    }
  };

  // handling customer accounts checkbox
  const checkboxOnChange = (c) => {
    if (!states.selectedColumns?.includes(c)) {
      let selected = [...states.selectedColumns, c];
      let data = [];

      let a = states.columns?.map((c) => {
        selected.map((s) => {
          if (c == s) {
            data = [...data, c];
          }
        });
      });

      setStates({
        selectedColumns: data,
      });
    } else {
      let arr = states.selectedColumns?.filter((e) => e !== c);
      setStates({
        selectedColumns: arr,
      });
    }
  };

  const pointsFormat = (value) => {
    if (value) {
      var nfObject = new Intl.NumberFormat("en-US");
      var points = nfObject.format(value);
      return points;
    }
    return "";
  };

  return (
    <div>
      <GlobalCss />
      {/* <div className={classes.headText}>
        Start date and End date{" "}
        {states.dateApplied && (
          <React.Fragment>
            <span className={classes.appliedSpan}>
              <CheckCircleIcon />
            </span>
            <span
              className={classes.removeSpan}
              onClick={() => {
                setStates({
                  dateApplied: false,
                  startDate: new Date(),
                  endDate: new Date(),
                });
              }}
            >
              Remove
            </span>
          </React.Fragment>
        )}
      </div>
      <div className={classes.inputsDiv}>
        <Grid container spacing={0}>
          <Grid item xs={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                label="Start Date"
                id="date-picker-inline"
                className={classes.dateInput}
                value={states.startDate}
                onChange={(date) => {
                  if (moment(date).isAfter(states.endDate)) {
                    toast.error("Start date should be greater than End date.", {
                      toastId: "start-date-end-date",
                    });
                    return;
                  }
                  setStates({ startDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                label="End Date"
                id="date-picker-inline2"
                className={classes.dateInput}
                value={states.endDate}
                onChange={(date) => {
                  if (moment(states.startDate).isAfter(date)) {
                    toast.error("Start date should be greater than End date.", {
                      toastId: "start-date-end-date",
                    });
                    return;
                  }
                  setStates({ endDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </div> */}
      {PointsBalance.filter.length > 0 && (
        <React.Fragment>
          {" "}
          <div className={classes.headText}>
            {t('Filter')}
            {states.filterApplied && (
              <React.Fragment>
                <span className={classes.appliedSpan}>
                  {" "}
                  <CheckCircleIcon />
                </span>
                <span
                  className={classes.removeSpan}
                  onClick={() => {
                    setStates({
                      filterApplied: false,
                      filterColumn: "",
                      filterValue: "",
                    });
                  }}
                >
                  {t('Remove')}
                </span>
              </React.Fragment>
            )}
          </div>
          <Grid container spacing={0} className={classes.inputsDiv}>
            <Grid item xs={3}>
              <TextField
                id={"filter-column"}
                label={t("Filter Column")}
                select
                type={"text"}
                className={classes.filterInput}
                value={states.filterColumn}
                onChange={(e) => {
                  setStates({
                    filterColumn: e.target.value,
                    filterApplied: true,
                  });
                }}
              >
                {PointsBalance.filter.map((r, i) => (
                  <MenuItem value={r.key} key={i}>
                    {r.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={3}>
              {states.filterColumn?.length > 0 && (
                <TextField
                  id={"filter-value"}
                  label={"Filter Value"}
                  required
                  type={"text"}
                  className={classes.filterInput}
                  value={states.filterValue}
                  onChange={(e) => {
                    setStates({
                      filterValue: e.target.value,
                    });
                  }}
                ></TextField>
              )}
            </Grid>
          </Grid>
        </React.Fragment>
      )}
      <div className={classes.headText}>
        {t('Sort by')}
        {states.groupByApplied && (
          <React.Fragment>
            <span className={classes.appliedSpan}>
              <CheckCircleIcon />
            </span>
            <span
              className={classes.removeSpan}
              onClick={() => {
                setStates({
                  groupByApplied: false,
                  groupBy: "",
                });
              }}
            >
              {t('Remove')}
            </span>
          </React.Fragment>
        )}
      </div>
      <Grid container spacing={0} className={classes.inputsDiv}>
        <Grid xs={12} lg={3}>
          <TextField
            id={"group"}
            label={t("Sort")}
            select
            type={"text"}
            className={classes.groupInput}
            value={states.groupBy}
            onChange={(e) => {
              setStates({
                groupBy: e.target.value,
                groupByApplied: true,
              });
            }}
          >
            {PointsBalance.group.map((r, i) => (
              <MenuItem value={r.key} key={i}>
                {t(r.label)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <div className={classes.headText}>{t('Select fields to be exported')}</div>
      <Grid container spacing={0} className={classes.inputsDiv}>
        {states.columns?.map((c, i) => (
          <Grid item xs={6}>
            <FormControlLabel
              key={i}
              control={
                <Checkbox
                  checked={states.selectedColumns?.includes(c)}
                  onChange={() => {
                    if (
                      (states.groupBy === "loyalty_id" && c === "Loyalty ID") ||
                      (states.groupBy === "customer_billto_account_number" &&
                        c == "Bill to Account ID")
                    ) {
                      return false;
                    }
                    checkboxOnChange(c);
                  }}
                  name="checkedB"
                  color="primary"
                />
              }
              label={t(c)}
            />
          </Grid>
        ))}
      </Grid>
      <CSVLink
        id="csv"
        // data={states.data}
        data={states.data.map(item => ({
          ...item,
          points_balance  : pointsFormat(item.points_balance),
          available_to_redeem : pointsFormat(item. available_to_redeem)
        }))}
        headers={states.selectedHeaders}
        filename={
          `PointsBalance` +
          " " +
          moment(new Date()).format("MM-DD-YYYY,h:mm A") +
          ".csv"
        }
        className={classes.CSVlink}
      />
      <div className={classes.exportAndPreview}>
        <Button
          className={classes.previewBtn}
          onClick={async () => {
            if (states?.selectedColumns.length == 0) {
              toast.error("Select atleast one Field.", {
                toastId: "empty-fields",
              });
              return;
            }
            if (states.filterApplied && !states.filterValue) {
              toast.error("Enter filter value.", {
                toastId: "filter-value",
              });
              return;
            }
            setStates({ response: false, data: [], pLoading: true });
            let res = await handlePointsBalance();
            if (res) {
              setStates({ dialog: true });
            }
          }}
          disabled={states.pLoading || states.eLoading}
        >
          {states.pLoading ? (
            <React.Fragment>
              <CircularProgress
                style={{ height: 25, width: 25 }}
                variant="determinate"
                value={state.reportResCount}
              />{" "}
              &nbsp;
              <span style={{ color: "#305698", fontWeight: "bold" }}>
                {state.reportResCount == 0 ?
                  <div class="snippet">
                    <div class="stage">
                      <div class="dot-typing-p"></div>
                    </div>
                  </div> : `${state.reportResCount}%`}
              </span>
            </React.Fragment>
          ) : (
            t("Preview")
          )}
        </Button>
        <Button
          className={classes.exportBtn}
          onClick={async () => {
            if (states?.selectedColumns.length == 0) {
              toast.error("Select atleast one Field.", {
                toastId: "empty-fields",
              });
              return;
            }
            if (states.filterApplied && !states.filterValue) {
              toast.error("Enter filter value.", {
                toastId: "filter-value",
              });
              return;
            }
            setStates({ response: false, data: [], eLoading: true });
            let res = await handlePointsBalance();
            if (res) {
              let data = [];
              document.getElementById("csv").click();
            }
          }}
          disabled={states.eLoading || states.pLoading}
        >
          {states.eLoading ? (
            <React.Fragment>
              <CircularProgress
                style={{ height: 25, width: 25, color: "#fff" }}
                variant="determinate"
                value={state.reportResCount}
              />
              &nbsp;
              <span style={{ color: "#fff", fontWeight: "bold" }}>
                {state.reportResCount == 0 ?
                  <div class="snippet">
                    <div class="stage">
                      <div class="dot-typing-e"></div>
                    </div>
                  </div> : `${state.reportResCount}%`}
              </span>
            </React.Fragment>
          ) : (
            t("Export CSV")
          )}
        </Button>
      </div>

      <Dialog
        onClose={() => {
          setStates({ dialog: false });
        }}
        aria-labelledby="simple-dialog-title"
        open={states.dialog}
      >
        <div className={classes.mainDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} className={classes.gridOne}>
              {page + " " + "Report"}
              <HighlightOffIcon
                className={classes.gridTwo}
                onClick={() => {
                  setStates({ dialog: false });
                }}
              />
            </Grid>
            <Grid item xs={12} className={classes.gridFive}>
              <span className={classes.gridThreeSpan}>{t('Generated Date')} : </span>
              <span>{dateFormat(moment(new Date()).format("MM-DD-YYYY"), i18n.language)}</span>
            </Grid>
          </Grid>
          {states.response ? (
            states.data && states.data.length > 0 ? (
              <TableContainer className={classes.tableContainer}>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={"medium"}
                  aria-label="enhanced table"
                >
                  <TableHead className={classes.tableHead}>
                    <TableRow>
                      {states.selectedColumns?.map((h, i) => (
                        <TableCell key={i} className={classes.tableHeading}>
                          <div
                            className={
                              (states.groupBy === "loyalty_id" &&
                                h === "Loyalty ID") ||
                                (states.groupBy ===
                                  "customer_billto_account_number" &&
                                  h == "Bill to Account ID")
                                ? classes.groupByMarker
                                : classes.noDisplay
                            }
                          >{`( ${t('Sort by')} )`}</div>
                          <div>{t(h)}</div>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {states.data?.slice(0, 10)?.map((p, i) => (
                      <TableRow role="checkbox" tabIndex={-1} key={i}>
                        {states.selectedFields.map((s) => (
                          <TableCell align="left" className={classes.rowCell}>
                            {s === "points_balance"
                              ? pointsFormat(p?.[s])
                              : t(p?.[s])}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <NoData />
            )
          ) : (
            <Loader Loading={!states?.response}></Loader>
          )}
        </div>
        {states.data && states.data.length > 0 && (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.gridFour}>
              <Button
                className={classes.previewBtn}
                onClick={() => {
                  setStates({ dialog: false });
                }}
              >
                {t('Cancel')}
              </Button>
              <Button
                className={classes.exportBtn}
                onClick={() => {
                  setStates({ dialog: false });
                  document.getElementById("csv").click();
                }}
              >
                {t('Export CSV')}
              </Button>
            </Grid>
          </Grid>
        )}
      </Dialog>
    </div>
  );
}
